export const BASE_API_URL = import.meta.env.VITE_API_URL
export const SESSION_STORAGE_KEY = `oidc.user:${import.meta.env.VITE_AUTHORITY}:${import.meta.env.VITE_CLIENT_ID}`
